import { useCallback } from 'react';
import {
  DTablePaginationConfig,
  DTableFilterValue,
  DTableSorterResult,
} from '@darwin-ui';
import { ProcessField, CustomProcessField } from 'types/dataTableTypes';
import useTableControls from 'hooks/useTableControls';
import { FormFields } from 'components/ui/dataTables/FieldsModal';

export const createTableChangeHandler = (
  tableControls: ReturnType<typeof useTableControls>,
  dataSource: ProcessField[] | CustomProcessField[]
) =>
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useCallback(
    (
      pagination: DTablePaginationConfig,
      filters: Record<string, DTableFilterValue | null>,
      sorter:
        | DTableSorterResult<ProcessField>
        | DTableSorterResult<ProcessField>[]
    ) => {
      tableControls.onTableChange(pagination, filters, sorter, {
        currentDataSource: dataSource,
        action: 'paginate',
      });
    },
    [tableControls, dataSource]
  );

export const createFieldPayload = (
  formData: FormFields,
  isEdit: boolean,
  fieldId?: string
) => ({
  processId: '', // Will be passed from component
  newField: {
    name: formData.fieldName,
    description: formData.description,
    type: formData.fieldType,
    formIds: formData.formIds,
    ...(formData.length !== '' && formData.length !== undefined
      ? { length: Number(formData.length) }
      : isEdit
      ? { length: null }
      : {}),
  },
  ...(isEdit && fieldId ? { fieldId } : {}),
});
